import { computed, defineComponent, provide, reactive, ref, toRefs } from 'vue'
import { getComponentNamespace, getNamespace } from '../../../utils/global-config'
import { stepsProps } from './props'
import { stepsInjectionKey } from './context'
import type { StepData } from './types'
const childrenName = getComponentNamespace('Step')

export default defineComponent({
  name: getComponentNamespace('Steps'),
  props: stepsProps,
  emits: ['update:current', 'change'],
  setup(props, { emit, slots }) {
    // 定义组件命名
    const ns = getNamespace('steps')
    // 组件class
    const cls = computed(() => [ns, props.direction && `${ns}--${props.direction}`])
    // 拿到非受控默认步数
    const _current = ref(props.defaultCurrent)
    // value
    const { current: currentRef } = toRefs(props)
    // 内部状态
    const innerCurrent = computed(() => currentRef.value ?? _current.value)
    /**
     * Step Click
     * @description 通过steps-item触发进行跳转
     * @param step
     * @param e
     */
    const handleClick = (step: number, e: Event) => {
      // 允许通过点击切换
      if (props.changeable) {
        _current.value = step
        emit('update:current', step)
        emit('change', step, e)
      }
    }
    /**
     * @description step save
     */
    const stepMap = reactive(new Map<number, StepData>())
    /**
     * 添加步骤及步骤数据
     * @param step
     * @param data
     */
    const addItem = (step: number, data: StepData) => {
      stepMap.set(step, data)
    }
    /**
     * 移除步骤及步骤数据
     * @param step
     */
    const removeItem = (step: number) => {
      stepMap.delete(step)
    }
    const components = (slots.default?.() || []).filter((item) => {
      return (item?.type as any)?.name === childrenName
    })
    const { lineType: lineTypeRef } = toRefs(props)
    /**
     * @description
     */
    provide(
      stepsInjectionKey,
      reactive({
        stepsType: props.type,
        innerCurrent,
        addItem,
        removeItem,
        onClick: handleClick,
        parentCls: ns,
        count: components.length,
        lineType: lineTypeRef
      })
    )
    return () => {
      return <div class={cls.value}>{components}</div>
    }
  }
})
